<template>
  <div id="bm-login">
    <div class="title" v-if="this.loginType === 'password'" >账号登录</div>
    <div class="title" v-if="this.loginType === 'sms'" >手机验证</div>
    <div class="main" >
      <van-tabs v-model="active">
        <van-tab v-if="loginType === 'password'" >
          <van-field
            v-model="login.tel"
            :error-message="validator.ErrMsg.tel"
            clearable
            type="text"
            placeholder="请输入账号ID">
          </van-field>

          <van-field
            v-model="login.password"
            :error-message="validator.ErrMsg.password"
            type="password"
            placeholder="请输入密码">
          </van-field>
          <van-button
            class="btn-log"
            @click="passwordLogin()"
            size="large">登录</van-button>
        </van-tab>
        <van-tab v-if="loginType === 'sms'" >
          <van-field
            v-model="smsLogin.tel"
            :error-message="smsValidator.ErrMsg.tel"
            clearable
            placeholder="请输入手机号">
          </van-field>
          <van-field
            v-model="smsLogin.sms"
            :error-message="smsValidator.ErrMsg.sms"
            center
            required
            placeholder="请输入短信验证码">
            <van-button slot="button" size="small" type="primary" @click="getSms()">{{ time ? time + 's后重新获取' : '发送验证码' }}</van-button>
          </van-field>
          <van-button class="btn-log" @click="smsEventLogin()" size="large">完成</van-button>
        </van-tab>
      </van-tabs>
    </div>
    <a v-if="loginType !== 'sms'" class="style-href" @click="loginType = 'sms'" >验证码登陆</a>
    <a v-if="loginType !== 'password'" class="style-href" @click="loginType = 'password'" >账号密码登陆</a>
    <router-link to="/register" class="style-href" >注册</router-link>
    <a class="style-href" @click="goBindEmail" >通过邮箱找回密码</a>
  </div>
</template>

<script>

import Vue from 'vue'
import _ from 'lodash'
import ValidatorUtils from '@/libs/validator'
import { Tab, Tabs, Button, Toast } from 'vant'
import { sendLoginSmsCode } from '@/api/user'
import { getAuditStatus, removeMembership, removeUserInfo, removeToken,
  removeRegisterInfo, removeOpenId, removeMemberType  } from '@/libs/cookie-storage'
import { getValidMembership } from '@/utils'

Vue.use(Tab).use(Tabs).use(Button).use(Toast)

export default {
  name: 'Login',
  data () {
    return {
      productList: [],
      validator: undefined,
      smsValidator: undefined,
      loginType: 'password',
      active: '',
      time: null,
      login: {
        tel: '',
        password: ''
      },
      smsLogin: {
        tel: '',
        sms: '',
        action: 'sendFastBindCode'
      },
      rules: {
        tel: [
          {
            validator: (rule, value, callBack) => {
              if (!value) {
                callBack('请输入账号ID')
              }
            }
          }
        ],
        password: [
          { required: true, message: '密码不能为空' }
        ]
      },
      smsRules: {
        tel: [
          {
            validator: (rule, value, callBack) => {
              if (!value) {
                callBack('请输入手机号码')
              } else if (/^[1][0-9]{10}$/.test(value)) {
                callBack()
              } else {
                callBack('请输入正确的手机号码')
              }
            }
          }
        ],
        sms: [
          { required: true, message: '请输入4位验证码' },
          {
            validator: (rule, value, callBack) => {
              /^\d{4}$/.test(value) ? callBack() : callBack('请输入4位验证码')
            }
          }
        ]
      }
    }
  },
  created() {
    this.validator = new ValidatorUtils({ rules: this.rules, data: this.login })
    this.login = this.validator.Data

    this.smsValidator = new ValidatorUtils({ rules: this.smsRules, data: this.smsLogin })
    this.smsLogin = this.smsValidator.Data

    removeMembership()
    removeUserInfo()
    removeToken()
    removeOpenId()
    removeRegisterInfo()
    removeMemberType()
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    reload() {
      location.reload()
    },
    passwordLogin() {
      this.validator.validate().then(
        (res) => {
          this.$store.dispatch('Login', this.login).then((res) => {
            if (res) {
              Toast({
                message: '登录成功'
              })
              this.handleRoutePush()
            }
          }
          )
        },
        (rej) => {
          this.$set(this.validator.errMsg)
          return false
        })
    },
    smsEventLogin() {
      this.smsValidator.validate().then(
        (res) => {
          this.$store.dispatch('SmsLogin', this.smsLogin).then((res) => {
            if (res) {
              Toast({
                message: '手机验证成功'
              })
              this.handleRoutePush()
            }
          }
          )
        },
        (rej) => {
          this.$set(this.smsValidator.errMsg)
          return false
        })
    },
    getSms() {
      if (this.time) {
        return
      }
      this.smsValidator.validate('tel').then(
        (res) => {
          sendLoginSmsCode(this.smsLogin.tel).then(
            (resolve) => {
              let sms = resolve.data.isSent
              if (sms) {
                this.countDown()
              }
            },
            (reject) => { }
          )
        },
        (rej) => {
          this.$set(this.smsValidator.errMsg)
          return false
        }
      )
    },
    handleRoutePush() {
      // 检测用户的注册审核流程 auditStatus 0 待审核，1 拒绝，2 通过，3 异常, 4 过期
      const validMemberShip = getValidMembership()
      const membership = validMemberShip.membership

      if (membership.length === 0) {
        this.$router.push('evpi')
      } else {
        const member = _.find(membership, function (item) {
          // return (item.paymentStatus > 0) && (item.status > 0) && (item.insurance && item.insurance.OrderNo) // 审核通过
          return (item.paymentStatus > 0) && (item.status > 0) // 教练员没有保险费，该逻辑去掉
        })
        if (member) {
          this.$router.push('ucenter')
        } else {
          // this.$router.push({path: 'review', query: {id: membership[0].status} }) TODO
          this.$router.push('review')
        }
      }
    },
    countDown() {
      this.time = 60
      let date = setInterval(() => {
        if (this.time <= 1) {
          this.time = null
          clearInterval(date)
          return
        }
        this.time -= 1
      }, 1000)
    },
    goBindEmail() {
      this.$router.push('forget-password')
    }
  }
}
</script>

<style>
  #bm-login {
    margin: 0 0.3rem;
  }

  #bm-login .title {
    font-size: 36px;
    color: #185494;
    font-weight:500;
    text-align: center;
    padding: 15px;
  }

  #bm-login .main .van-cell:first-child {
    margin-top: 10px;
  }

  #bm-login .style-href {
    display: block;
    text-align: center;
    padding: 15px;
    color:rgba(129,129,129,1);
    font-size: 16px; /*no*/
  }

  #bm-login .van-field__body {
    height: 50px;
    line-height: 50px;
    background:rgba(248,248,248,1);
  }

  #bm-login .van-field__body .van-field__control {
    text-indent: 15px;
    font-size: 16px;
  }

  #bm-login .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #bm-login .van-field__body .van-field__button:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 30px;
    background-color: #CFCFCF;
    top: 10px;
  }

  #bm-login .van-field__body .van-field__button .van-button {
    background-color: transparent;
    border: none;
    color: #185494;
    padding: 0 15px;
  }

  #bm-login .van-field__error-message {
    text-indent: 15px;
  }

  #bm-login .btn-log {
    height:60px;
    border-radius:2px;
    border: none;
    margin-top: 30px;
    font-weight:400;
    color:rgba(129,129,129,1);
    font-size:20px;
    background-color: #185494;
    color: white;
  }

  #bm-login .van-cell {
    padding: 8px 0;
  }

  #bm-login .van-tabs__line {
    background-color: transparent;
  }

  #bm-login .van-hairline--top-bottom::after {
    border-width: 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/login.vue